import styled from "styled-components";

export const ContainerDiv = styled.div<{ $fullHeight: boolean }>`
  width: 100%;
  padding: 0 24px;
  padding-right: 12px;
  ${(props) => props.$fullHeight && `height: 100%;`}
`;
